import React, { Fragment } from 'react';

import './groupedContainer.scss';
import { Grid } from '@mui/material';

export const GroupedContainer = ({ children, sectionTitle, ungrouped }) => {

    if (ungrouped) return <Fragment>{children}</Fragment>;

 return <Grid size={{ xs: 100 }}>
        <div className='form-group-container'>
            <div className='form-group-label'>
                <label>{sectionTitle}</label>
            </div>
            <Grid container columnSpacing={3}
                rowSpacing={3}
                columns={100}>
                {children}
            </Grid>
        </div>
    </Grid>
} 